export const ProductMixin = {
    name: "ProductMixin",
    computed: {
        product: {
            get() {
                return this.$store.state.product
            },
            set(value) {
                this.$store.commit('product/init', value);
            }
        },
        isLoaded() {
            return this.$store.getters['product/isLoaded'];
        },
        selectedVariable() {
            return this.$store.getters['product/selectedVariable'];
        },
        stock() {
            if(this.product.type === 'variable' && this.selectedVariable && typeof this.selectedVariable.stocks[0] !== "undefined") {
                return this.selectedVariable.stocks[0];
            }
            if(this.product.type === 'simple' && this.product.stocks && typeof this.product.stocks[0] !== "undefined") {
                return this.product.stocks[0];
            }
        },
        productUrl() {
            return this.appUrl('product/'+this.product.slug);
        }
    },
    methods: {
        request(slug) {
            const config = {};
            if (localStorage.getItem('_token')) {
                config.headers = {
                    Authorization: 'Bearer '+localStorage.getItem('_token')
                };
            }
            this.axios.get(this.route('api.product.show', slug), config).then(response => {
                this.product = response.data.data;
            });
        }
    }
}
